import {    
    createActionResources,    
} from "redux-waiters";

export const searchCreditBundles = createActionResources("credits/search");
export const saveCreditBundles = createActionResources("credits/save");
export const deleteCreditBundles = createActionResources("credits/delete");
export const getCreditRate = createActionResources("credits/rate");